<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
  import {addQueryParams} from '../libs/url';
  import AjaxErrorHandler from '../mixins/ajax-errors';

  export default {
    mixins: [
      AjaxErrorHandler
    ],

    props: {
      baseUrl: null,
      currentPage: {
        type: Number,
        default: 1
      },
      items: {
        type: null,
        default: null,
      },
      current: {
        type: null,
        default: null,
      },
    },

    data() {
      return {
        cancelToken: null,
        isRequestActive: false,
      };
    },

    computed: {
      url() {
        return addQueryParams(this.baseUrl, {page: this.currentPage});
      },
    },

    watch: {
      url: {
        handler: function () {
          this.refresh()
        },
        immediate: true
      },

      isRequestActive(value) {
        if (value) {
          this.$emit('refresh', true);
        } else {
          this.$emit('refresh', false);
        }
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      performLoading() {
        if (this.isRequestActive) {
          this.cancelToken.cancel();
        } else {
          this.isRequestActive = true;
        }

        this.cancelToken = axios.CancelToken.source();

        axios.get(this.url, {
          cancelToken: this.cancelToken.token,
          params: {page: this.page}
        })
          .then(this.onLoadSuccess)
          .catch(this.onLoadError)
          .then((isCancelled) => {
            if (isCancelled !== true) {
              this.isRequestActive = false;
            }
          });
      },

      /**
       * @param {Object} data
       * @return {Boolean}
       */
      onLoadSuccess({data: {data: items, meta}}) {
        this.$emit('load-success', {items, meta});
      },

      /**
       * @param {Object} error
       * @return {Boolean}
       */
      onLoadError(error) {
        this.handleErrorResponse(error);
        this.$emit('load-error', error);

        return axios.isCancel(error);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.performLoading();
      },
    },
  }
</script>

